import React from "react";
import './AboutUs.css'


export default function AboutUs() {
    return (
        <div className="aboutUs">
          
           
             <div className="container">
                <div className="row">
                   <div className="col-md-6">
                   <div>
               <h2>Elevating Your Brand with Exceptional Printing Services</h2>
                <p>At Printingy, we believe in transforming ideas into tangible masterpieces through innovative printing solutions. Serving industries such as retail, education, hospitality, and corporate sectors, we bring your vision to life with precision and creativity. Whether it’s custom designs, vibrant marketing materials, or sustainable printing options, our commitment to quality ensures your projects are handled with care and expertise. From small-scale projects to large production runs, we tailor our services to meet your exact requirements. Trust Printingy to deliver impactful printing solutions that not only reflect your brand’s essence but also leave a lasting impression.</p>
               </div>
                   </div>
                   <div className="col-md-6">
                   <div className="bgAbout">
                    <div className="abtImg">
                    <img  src="/imgonabotu.jpg" />
                    </div>
                  
                   </div>
                   </div>
                </div>

             </div>
           
        </div>
    );
}
